import React, { Component } from 'react'

import RidingTable from '../Tables/RidingTable'
import DownloadDataLink from '../Tables/DownloadDataLink'

class FederalRidings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: null
    }
    this.applyFilter = this.applyFilter.bind(this)
  }

  applyFilter (filter) {
    this.setState({ filter })
  }

  render () {
    const data = {}

    const ridingSets = ['fed']

    ridingSets.forEach(key => {
      data[key] = this.props.data.ridings && this.props.data.ridings[key]
        ? Object.values(this.props.data.ridings[key])
        : {}
    })

    const id = 'fed-ridings'

    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h1>Federal ridings</h1>
            <DownloadDataLink forId={id} filename={id} />
          </div>
        </div>
        <RidingTable id={id} ridings={data.fed} showProvince />
      </div>
    )
  }
}

export default FederalRidings



// WEBPACK FOOTER //
// ./src/components/App/FederalRidings.js